import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Modal from './Modal';


class ScrollableModal extends Component {
    static propTypes = {
        ...Modal.propTypes,
        /** The time in ms that the modal will pause after open before initiating scroll. */
        pauseBeforeScroll: PropTypes.number,
        /** Duration of scroll in ms. */
        scrollDuration: PropTypes.number,
        /** A CSS selector that finds the body element to scroll to. */
        scrollSelector: PropTypes.string,
        /** Function that renders passed in modal jsx content. */
        renderModalContent: PropTypes.func,
        /** Function to be called when the modal opens. */
        onModalOpen: PropTypes.func,
        /** Function that initiates a scroll to the scrollSelector element. */
        scrollTo: PropTypes.func
    }

    static defaultProps = {
        ...Modal.defaultProps,
        pauseBeforeScroll: 500,
        scrollDuration: 1000,
        scrollSelector: '',
        renderModalContent: () => {},
        onModalOpen: () => {},
        scrollTo: () => {}
    }

    scrollToCssSelector = (selector, modalBodyElement) => {
        const {
            pauseBeforeScroll,
            scrollDuration,
            scrollTo
        } = this.props;

        setTimeout(() => {
            const modalRect = modalBodyElement.getClientRects();
            const element = window.document.querySelector(`.Modal__body ${selector}`);
            if (element) {
                const elementRect = element.getClientRects();
                const newTop = elementRect['0'].top - modalRect['0'].top;

                scrollTo(modalBodyElement, newTop, scrollDuration);
            }
        }, pauseBeforeScroll);
    };

    scrollOnOpen = (modalStructure, modalBodyElement) => {
        const {
            scrollSelector,
            onModalOpen
        } = this.props;

        if (onModalOpen) {
            onModalOpen();
        }

        if (scrollSelector) {
            this.scrollToCssSelector(scrollSelector, modalBodyElement);
        }
    };

    scrollToTopOfModal = (modalBodyElement) => {
        const {
            scrollToTop,
            scrollDuration
        } = this.props;

        scrollToTop(modalBodyElement, 0, scrollDuration);
    };

    render() {
        const {
            renderModalContent,
            // grab unused vars to prevent rest from being passed down as propertys on the modal div
            scrollTo, // eslint-disable-line no-unused-vars
            scrollToTop, // eslint-disable-line no-unused-vars
            scrollDuration, // eslint-disable-line no-unused-vars
            scrollSelector, // eslint-disable-line no-unused-vars
            onModalOpen, // eslint-disable-line no-unused-vars
            pauseBeforeScroll, // eslint-disable-line no-unused-vars
            ...rest
        } = this.props;

        return (
            <Modal
                onModalOpen={this.scrollOnOpen}
                scrollToTop={this.scrollToTopOfModal}
                isWorkflow
                {...rest}
            >
                {renderModalContent()}
            </Modal>
        );
    }
}

export default ScrollableModal;
